// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3iMstOImrLVD1LFof5q28H"};


//////////////////
// WEBPACK FOOTER
// ./components/easinsure/contracts/EasinsureContracts.scss
// module id = 1164
// module chunks = 0